import {
    AnalysisType,
    Project,
    ProjectAnalysisStatus,
    ProjectStatus,
    ProjectType,
} from "../../../types/ProjectTypes";
import { MSA_DOC, ORDER_FORM_DOC } from "./demoScript";

// Sentinel ID used to recognize the demo project. Picked deliberately high so
// it can't collide with anything served from the backend.
export const DEMO_PROJECT_ID = 999_999_001;

// In-memory store keyed by project id. The patched `getProject` in
// ProjectClient.ts checks this map before hitting the API so the demo's
// guided-intake submission can navigate to the real ProjectView.
const store = new Map<number, Project>();

export function setFakeProject(project: Project): void {
    store.set(project.id, project);
}

export function getFakeProject(id: number): Project | undefined {
    return store.get(id);
}

export function clearFakeProject(id: number): void {
    store.delete(id);
}

/** Build a minimal Project for the guided-intake demo, in the "pending
 *  analysis" state — the user lands on this immediately after submitting. */
export function buildDemoPendingProject(projectName: string): Project {
    const now = new Date();
    // The Project type expects a `User` for creator/owner; the rendering code
    // in ProjectView's pending state only uses identity fields, so a minimal
    // stub is enough.
    const stubUser = {
        id: 0,
        email: "demo@infinityloop.local",
        name: "Demo Customer",
        firstName: "Demo",
        lastName: "Customer",
        avatar: "",
        type: "User",
        status: "active",
        roles: [],
        timezone: "UTC",
        guided: false,
    } as unknown as Project["creator"];

    const stubDoc = (id: number, filename: string) => ({
        id,
        document: {
            id,
            name: filename,
            documentSerialId: `demo-doc-${id}`,
            uploadDate: now,
            objectLocation: { Bucket: "", Key: "" },
            pageCount: 0,
        },
        isDeleted: false,
        recordCreationDate: now,
        creator: stubUser,
    });

    return {
        id: DEMO_PROJECT_ID,
        organizationId: 0,
        name: projectName || "AWS Private Pricing Addendum",
        type: ProjectType.DEAL,
        status: ProjectStatus.ACTIVE,
        creator: stubUser,
        creatorId: 0,
        owner: stubUser,
        ownerId: 0,
        recordCreationDate: now,
        recordUpdateDate: now,
        lastUpdateDate: now,
        submittedDate: now,
        documents: [
            stubDoc(1, ORDER_FORM_DOC.filename),
            stubDoc(2, MSA_DOC.filename),
        ],
        allowedActions: [],
        analyses: [
            {
                id: 1,
                type: AnalysisType.DEAL,
                version: 1,
                status: ProjectAnalysisStatus.SUBMITTED,
                creator: stubUser,
                recordCreationDate: now,
                recordUpdateDate: now,
                submittedDate: now,
                documents: [],
                inputs: [],
            },
        ],
    };
}
